import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';
import { BuildingOpeningDay } from '../models/booking/building-opening-day.model';

/**
 * Validation function that returns an error if the selected date is not within the building opening days
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function outOfOpeningDays(reference: BuildingOpeningDay[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!reference) {
      return null;
    }

    for (const openingDay of reference) {
      if (moment(control.value).isoWeekday() === openingDay.day) {
        return openingDay.isOpen === false ? {outOfOpeningDays: {value: control.value}} : null;
      }
    }

    return null;
  };
}
